import { FC } from "react";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { toast } from "react-toastify";

interface CredentialsBoxProps {
  username: string;
  password?: string;
  showCopyButton?: boolean;
}

const CredentialsBox: FC<CredentialsBoxProps> = ({
  username,
  password,
  showCopyButton = true,
}) => {
  const { palette } = useTheme();

  const handleCopyCredentials = () => {
    const credentialsText = password
      ? `Username: ${username.toLowerCase()}\nPassword: ${password}`
      : `Username: ${username.toLowerCase()}`;
    navigator.clipboard.writeText(credentialsText);
    toast.success("Credentials copied to clipboard");
  };

  return (
    <Box
      sx={{
        backgroundColor: palette.grey[500],
        borderRadius: "8px",
        padding: "16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          color: palette.grey[100],
        }}
      >
        <Box>
          <Typography variant="labelLarge">Username:</Typography>
          <Typography variant="bodyMedium">
            {" "}
            {username.toLowerCase()}
          </Typography>
        </Box>
        {password && (
          <Box>
            <Typography variant="labelLarge">Password:</Typography>
            <Typography variant="bodyMedium"> {password}</Typography>
          </Box>
        )}
      </Box>
      {showCopyButton && (
        <IconButton
          onClick={handleCopyCredentials}
          sx={{
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
          }}
        >
          <ContentCopy />
        </IconButton>
      )}
    </Box>
  );
};

export default CredentialsBox;
